<!--  -->
<template>
  <div style="display: flex; justify-content: center; overflow-x: auto">
    <el-form
      label-position="right"
      label-width="150px"
    >
      <el-form-item
        v-if="login_type != 2 && login_type != 3"
        label=""
        style="width: 100%; height: 10px"
      >
        <el-button
          style="float: right; margin-bottom: 5px"
          type="success"
          icon="el-icon-plus"
          circle
          :disabled="formLabelAlign.length >= 2"
          @click="copy"
        />
      </el-form-item>
      <el-form-item
        v-if="login_type==2 || login_type==3"
        label="登录状态"
        style="width: 100%; height: 10px"
      >
        <div v-if="login_status == 1">
          <el-button
            type="primary"
            size="mini"
            @click="loginqr"
          >登录</el-button>
        </div>
        <div v-if="login_status == 2"><el-tag>已登录</el-tag> <el-button
          type="danger"
          size="mini"
          @click="logouout"
        >登出</el-button></div>
      </el-form-item>
      <div style="max-height: 900px; overflow-y: auto; overflow-x: auto; width: 100%">
        <div
          v-for="(item, i) in formLabelAlign"
          :key="i"
        >
          <el-card style="width: 100%; margin: 5px 150px 20px 0">
            <el-form-item label="企业名称">
              <el-select
                v-model="item.corp_id"
                filterable
                placeholder="请选择"
                @change="seraw(item.box_id)"
              >
                <el-option
                  v-for="opt in corpidoptions"
                  :key="opt.corp_id"
                  :label="opt.corp_name"
                  :value="opt.corp_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="员工名称">
              <!-- <el-select v-model="item.corp_user_id" filterable placeholder="请选择" :disabled="item.corp_id === null">
                <el-option v-for="item in corpuseridoptions" :key="item.user_id" :label="item.name" :value="item.user_id" />
              </el-select> -->
              <el-tag
                v-if="item.corp_user_id"
                style="margin-right: 10px"
              >{{ item.corp_user_name }}</el-tag>
              <el-button
                type="primary"
                size="mini"
                @click="swewqrq(item.box_id,item.corp_id)"
              >选择员工</el-button>
            </el-form-item>
            <el-form-item label="企微应用序号">
              <!-- <el-input v-model="item.app_no" style="width: 50%" @blur="validateInput" /> -->
              <el-radio-group v-model="item.app_no">
                <el-radio-button :label="1">1</el-radio-button>
                <el-radio-button
                  v-if="login_type!=2 && login_type!=3 && login_type!=4"
                  :label="2"
                >2</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="转发源企业员工">
              <el-tag>{{ item.employee_name }}</el-tag>
              <el-tag
                style="margin-left: 8px"
                effect="dark"
                @click="changeSource(item.box_id)"
              >{{ !item.choose ? '修改' : '选择' }}</el-tag>
            </el-form-item>
            <el-form-item label="接粉号">
              <el-tag>{{ item.accept_employee_name }}({{ item.accept_corp_name }})</el-tag>
              <el-tag
                style="margin-left: 8px"
                effect="dark"
                @click="changeelmentw(item.box_id)"
              >选择</el-tag>
            </el-form-item>
            <el-form-item label="推粉开关">
              <el-switch
                v-model="item.accept_switch"
                :active-value="2"
                :inactive-value="1"
                inactive-text="关"
                active-text="开"
              />
            </el-form-item>
            <!-- v-if="item.accept_employee_no" -->
            <el-form-item>
              <el-button
                type="warning"
                size="mini"
                style="margin-left:0;"
                @click="openResetDialog(item)"
              >重置名片推送</el-button>
              <el-tag type="success" style="margin: 0 10px;">单删粉：{{ item.delete_fans_count }}</el-tag>
              <el-tag type="success">活粉：{{ item.valid_fans_count }}</el-tag>
            </el-form-item>
            <el-form-item>
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  @click="starte(item)"
                >开始推送名片</el-button>
              </div>
            </el-form-item>
            <el-button
              style="float: right; margin-bottom: 10px"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteitem(i)"
            />
          </el-card>
        </div>
      </div>
      <el-form-item
        label=""
        style="width: 100%; height: 10px"
      >
        <el-button
          style="float: right"
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="转发源企业员工"
      :visible.sync="relevanceVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <soucelist
        ref="soucelistview"
        @labelchoose="labelchoose"
      />
    </el-dialog>
    <el-dialog
      title="承接企业员工"
      :visible.sync="cekwerwVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <soucelisttwo
        ref="soucelisttwoview"
        @labelsiurwe="labelsiurwe"
      />
    </el-dialog>
    <el-dialog
      title="选择员工"
      :visible.sync="employeenodialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <chooseemployeeno
        ref="chooseemployeenoview"
        @callbackwer="callbackwer"
      />
    </el-dialog>
    <el-dialog
      title="登录云手机"
      :visible.sync="logindialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="guandengl"
    >
      <div style="display: flex;flex-direction: column;align-items: center;">
        <div style="color:#F56C6C">请扫码登录云手机</div>
        <div
          v-loading="qrcodedialogloading"
          class="qr_boxr"
          element-loading-background="transparent"
        >
          <div
            v-if="qrcodedialogloading === true"
            style="text-align:center;width:280px;height: 470px;line-height: 470px;"
          >加载中...</div>
          <img
            v-if="qrurl!=''"
            style="width:280px;height: 470px;"
            :src="qrurl"
          >
          <div
            v-if="errorloading === true"
            style="text-align:center;width:280px;height: 470px;line-height: 470px;"
          >加载失败</div>
          <!-- <el-image
            style="width:280px;height: 470px;"
            :src="qrurl"
          ></el-image> -->
          <!-- :fit="'fill'" -->
        </div>
        <el-input
          v-model="verificationcode"
          style="width:200px"
          placeholder="请输入验证码"
        />
        <div style="margin-top:20px;width:60%;text-align:right">
          <el-button
            type="success"
            @click="sunbmitok"
          >确定登录</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="选择推粉类型"
      :visible.sync="fansTypeDialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
    >
      <div style="margin-bottom: 20px; color: #F56C6C;">
        <div>该选项单选</div>
      </div>
      <el-radio-group v-model="fansType">
        <el-radio :label="1">全量</el-radio>
        <el-radio :label="2">单删</el-radio>
        <el-radio :label="3">活粉</el-radio>
      </el-radio-group>
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <div style="flex-shrink: 0;">推送数量：</div>
        <el-input-number
          v-model="sendNum"
          :min="1"
          :precision="0"
          style="width: 100%;"
        />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="fansTypeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmStartPush">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="重置名片推送"
      :visible.sync="resetDialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
    >
      <div style="margin-bottom: 20px; color: #F56C6C;">
        <div>可多选</div>
      </div>
      <el-checkbox-group v-model="resetFansTypes">
        <el-checkbox :label="1">全量</el-checkbox>
        <el-checkbox :label="2">单删</el-checkbox>
        <el-checkbox :label="3">活粉</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="resetLoading" @click="confirmResetBusinessCard">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { filterCorplist, filterUser, phoneRelationstore, phoneRelationindex, phoneRelationstoredelte, vephonesdkqrcode, workWechatVerifyCode, workWechatloginOut, esetBusinessCard, spWorkWechatphoneRelationcheck, openBusinessCardSwitch } from '@/api/enterprisewechatControl'
import soucelist from './soucelist.vue'
import soucelisttwo from './soucelisttwo.vue'
import chooseemployeeno from './chooseemployeeno.vue'
export default {
  components: { soucelist, soucelisttwo, chooseemployeeno },
  data() {
    return {
      formLabelAlign: [
        {
          box_id: 1,
          corp_id: null,
          phone_id: null,
          corp_user_id: null,
          choose: false,
          employee_name: '暂无数据',
          source_employee_no: null, // 转发源员工编号
          app_no: 1, // 应用序号
          accept_corp_name: '',
          accept_employee_name: '',
          accept_employee_no: '',
          accept_switch: 1,
          corp_user_name: ''
        }
      ],
      query: {
        phone_id: '',
        page: 1,
        page_size: 10
      },
      corpidoptions: [],
      corpuseridoptions: [],
      ph_id: null,
      relevanceVisible: false,
      boxIdCounter: 1,
      cekwerwVisible: false,
      employeenodialog: false,
      login_type: null,
      login_status: null,
      logindialog: false,
      qrurl: '',
      verificationcode: '',
      equipment_code: null,
      qrcodedialogloading: false,
      errorloading: false,
      fansTypeDialogVisible: false, // 推粉类型选择弹窗
      currentEmployeeNo: '', // 当前操作的员工编号
      fansType: null, // 选择的推粉类型（单选，用于开始推送名片）
      sendNum: 1, // 推送数量，最小值为1
      resetDialogVisible: false, // 重置名片推送弹窗
      resetFansTypes: [], // 重置时选择的推粉类型（多选）
      resetLoading: false // 重置loading状态
    }
  },
  methods: {
    send(id, login_type, login_status, equipment_code) {
      console.log('login_type', login_type, equipment_code)
      this.ph_id = id
      this.login_type = login_type
      this.login_status = login_status
      this.equipment_code = equipment_code
      this.availablelist()
      this.list()
    },
    // 回显列表
    async availablelist() {
      this.query.phone_id = this.ph_id
      const data = await phoneRelationindex(this.query)
      this.formLabelAlign = data.data.list
      if (data.data.list.length === 0) {
        this.formLabelAlign = [
          {
            box_id: 1,
            corp_id: null,
            phone_id: null,
            corp_user_id: null,
            choose: true,
            employee_name: '暂无数据',
            source_employee_no: null,
            app_no: 1,
            accept_corp_name: '',
            accept_employee_name: '',
            accept_employee_no: '',
            accept_switch: 1,
            corp_user_name: ''
          }
        ]
      } else {
        this.formLabelAlign = data.data.list.map(item => ({
          ...item,
          box_id: this.boxIdCounter++,
          employee_name: `${item.source_employee_name}（${item.source_corp_name}）`
        }))

        console.log(this.formLabelAlign)
      }
      this.sdawr()
    },
    // 企业名称筛选
    async list() {
      const data = await filterCorplist()
      this.corpidoptions = data.data
    },
    // 员工名称筛选
    async sdawr() {
      const data = await filterUser({
        corp_id: this.formLabelAlign[0].corp_id
      })
      this.corpuseridoptions = data.data
    },

    labelchoose(item, box_id) {
      this.relevanceVisible = false
      // 处理选中之后回显
      const targetItem = this.formLabelAlign.find(i => i.box_id === box_id)
      if (targetItem) {
        // 修改目标元素的属性
        targetItem.employee_name = item.name ? `${item.name}(${item.corp_name})` : '暂找不到数据'
        targetItem.source_employee_no = item.employee_no
        targetItem.choose = false
      }
    },

    seraw(box_id) {
      this.formLabelAlign.find(item => item.box_id === box_id).corp_user_id = null
      this.corpuseridoptions = []
      this.sdawr()
    },

    validateInput(e) {
      if (!['1', '2'].includes(e.target.value)) {
        e.target.value = '' // 清空输入框
        this.$message({
          message: '请输入正确的序号',
          type: 'error'
        })
      }
    },

    // 删除一个
    deleteitem(index) {
      if (this.formLabelAlign[index].id) {
        this.$confirm('此操作将删除此条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        })
          .then(() => {
            phoneRelationstoredelte({ id: this.formLabelAlign[index].id }).then(res => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.availablelist()
            })
          })
          .catch(() => {})
      } else {
        this.formLabelAlign.splice(index, 1)
        this.formLabelAlign.forEach((item, i) => {
          item.box_id = i + 1
        })
      }
    },
    // 新增一个
    copy() {
      this.formLabelAlign.push({
        box_id: this.formLabelAlign.length + 1,
        corp_id: null,
        phone_id: null,
        corp_user_id: null,
        choose: true,
        employee_name: '暂无数据',
        source_employee_no: null, // 转发源员工编号
        app_no: this.formLabelAlign[0].app_no === 1 ? 2 : 1, // 应用序号
        accept_corp_name: '',
        accept_employee_name: '',
        accept_employee_no: '',
        accept_switch: 1,
        corp_user_name: ''
      })
    },

    changeSource(box_id) {
      this.relevanceVisible = true
      this.$nextTick(() => {
        this.$refs.soucelistview.send(box_id)
      })
    },

    async sumbit() {
      this.formLabelAlign.map(item => (item.phone_id = this.ph_id))
      const isValid = this.formLabelAlign.every((item, index) => {
        if (!item.corp_id) {
          this.$message({
            message: '请选择企业名称',
            type: 'error'
          })
          return false
        } else if (!item.corp_user_id) {
          this.$message({
            message: '请选择员工名称',
            type: 'error'
          })
          return false
        } else if (!item.app_no) {
          this.$message({
            message: '请选择企微应用序号',
            type: 'error'
          })
          return false
        } else if (item.employee_name === '暂无数据') {
          this.$message({
            message: '请选择转发源企业员工',
            type: 'error'
          })
          return false
        }
        // else if (item.app_no !== 1 && item.app_no !== 2) {
        //   this.$message({
        //     message: '请输入正确的序号',
        //     type: 'error'
        //   })
        //   return false
        // }

        // 检查是否有重复的 app_no
        const hasDuplicateAppNo = this.formLabelAlign.some((otherItem, otherIndex) => {
          return index !== otherIndex && item.app_no === otherItem.app_no
        })
        if (hasDuplicateAppNo) {
          this.$message({
            message: '不能输入相同的企微序号',
            type: 'error'
          })
          return false
        }

        return true
      })

      if (isValid) {
        const data = {
          relations: this.formLabelAlign
        }
        // await phoneRelationstore(data)
        // this.$message({
        //   message: '关联成功',
        //   type: 'success'
        // })
        // this.$emit('updata')
        spWorkWechatphoneRelationcheck(data).then((res) => {
          console.log('res', res)
          // eslint-disable-next-line eqeqeq
          if (res.data.notice.length == 0) {
            console.log('空数组')
            phoneRelationstore(data).then((res) => {
              this.$message({
                message: '关联成功',
                type: 'success'
              })
              this.$emit('updata')
            })
          } else {
            console.log('不是空数组', res.data.notice)

            const noticeList = res.data.notice || []
            // 拼接成换行字符串
            const noticeText = noticeList.map((item, index) => `${index + 1}. ${item}`).join('<br/>')

            this.$confirm(
              `${noticeText}<br/>是否继续保存?`,
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true // 允许 html 显示换行
              }
            ).then(() => {
              phoneRelationstore(data).then((res) => {
                this.$message({
                  message: '关联成功',
                  type: 'success'
                })
                this.$emit('updata')
              })
            }).catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
          }
        })
      }
    },
    changeelmentw(box_id) {
      this.cekwerwVisible = true
      this.$nextTick(() => {
        this.$refs.soucelisttwoview.send(box_id)
      })
    },
    labelsiurwe(item, box_id) {
      this.cekwerwVisible = false
      // 处理选中之后回显
      const targetItem = this.formLabelAlign.find(i => i.box_id === box_id)
      if (targetItem) {
        console.log('item666', item)
        // 修改目标元素的属性
        targetItem.accept_corp_name = item.corp_name
        targetItem.accept_employee_name = item.name
        targetItem.accept_employee_no = item.employee_no
      }
    },
    swewqrq(box_id, corp_id) {
      this.employeenodialog = true
      this.$nextTick(() => {
        this.$refs.chooseemployeenoview.send(box_id, corp_id)
      })
    },
    callbackwer(item, box_id) {
      this.employeenodialog = false
      // 处理选中之后回显
      const targetItem = this.formLabelAlign.find(i => i.box_id === box_id)
      if (targetItem) {
        console.log('item666', item)
        // 修改目标元素的属性
        targetItem.corp_user_name = item.name
        targetItem.corp_user_id = item.user_id
      }
    },
    loginqr() {
      this.logindialog = true
      this.qrcodedialogloading = true
      vephonesdkqrcode({
        equipment_code: this.equipment_code,
        type: this.login_type
      })
        .then(res => {
          this.qrcodedialogloading = false
          this.qrurl = res.data.url
          console.log('res', res)
        })
        .catch(err => {
          console.log('err加载失败', err)
          this.qrcodedialogloading = false
          this.errorloading = true
        })
    },
    sunbmitok() {
      if (this.verificationcode === '') {
        this.$message.error('请输入验证码')
        return
      }
      workWechatVerifyCode({
        equipment_code: this.equipment_code,
        type: this.login_type,
        code: this.verificationcode
      }).then(res => {
        this.$message({
          type: 'success',
          message: '登录成功!'
        })
        this.$emit('updata')
        this.logindialog = false
      })
    },
    guandengl() {
      console.log('关闭')
      this.verificationcode = ''
      this.qrurl = ''
      this.qrcodedialogloading = false
      this.errorloading = false
      // 关闭
    },
    logouout() {
      workWechatloginOut({
        equipment_code: this.equipment_code,
        type: this.login_type
      }).then(res => {
        this.$message({
          type: 'success',
          message: '登出成功!'
        })
        this.$emit('updata')
        this.logindialog = false
      })
    },
    openResetDialog(item) {
      if (!item.employee_no) {
        this.$message.error('员工编号不能为空')
        return
      }
      this.currentEmployeeNo = item.employee_no
      this.resetFansTypes = []
      this.resetDialogVisible = true
    },
    async confirmResetBusinessCard() {
      if (!this.resetFansTypes || this.resetFansTypes.length === 0) {
        this.$message.error('请至少选择一个推粉类型')
        return
      }
      if (!this.currentEmployeeNo) {
        this.$message.error('员工编号不能为空')
        return
      }
      this.resetLoading = true
      try {
        await esetBusinessCard({
          employee_no: this.currentEmployeeNo,
          fans_types: this.resetFansTypes
        })
        this.$message.success('重置名片推送成功')
        this.resetDialogVisible = false
        this.resetFansTypes = []
        this.currentEmployeeNo = ''
      } catch (e) {
        this.$message.error('重置失败，请稍后重试')
      } finally {
        this.resetLoading = false
      }
    },
    starte(item) {
      console.log('item', item)
      this.currentEmployeeNo = item.employee_no
      this.fansType = null
      this.sendNum = 1
      this.fansTypeDialogVisible = true
    },
    async confirmStartPush() {
      if (!this.fansType) {
        this.$message.error('请选择推粉类型')
        return
      }
      if (!this.currentEmployeeNo) {
        this.$message.error('员工编号不能为空')
        return
      }
      if (!this.sendNum || this.sendNum < 1) {
        this.$message.error('推送数量不能小于1')
        return
      }
      try {
        await openBusinessCardSwitch({
          employee_no: this.currentEmployeeNo,
          action: 2,
          fans_type: this.fansType,
          send_num: this.sendNum
        })
        this.$message({
          type: 'success',
          message: '创建推送名片任务成功!'
        })
        this.fansTypeDialogVisible = false
        this.fansType = null
        this.sendNum = 1
        this.currentEmployeeNo = ''
      } catch (error) {
        this.$message.error('创建推送名片任务失败，请稍后重试')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
::v-deep .el-card__body {
  padding: 15px 0 0 0;
}
.qr_boxr {
  margin: 20px 0px;
}
@media (max-width: 768px) {
    .el-form-item {
        overflow: visible !important;
    }
}
</style>
